export type StoredLocation={
  latitude:number;longitude:number;accuracy?:number;province:string;city:string;district:string;adcode:string;label:string;updatedAt:string;
};

export function requestCurrentPosition(){
  return new Promise<{latitude:number;longitude:number;accuracy:number}>((resolve,reject)=>{
    if(!navigator.geolocation){reject(new Error("当前浏览器不支持定位"));return}
    navigator.geolocation.getCurrentPosition(
      position=>resolve({latitude:position.coords.latitude,longitude:position.coords.longitude,accuracy:position.coords.accuracy}),
      error=>reject(new Error(error.code===1?"定位权限被拒绝，请在浏览器设置中允许位置权限":error.code===3?"定位等待超时，请再试一次":"暂时无法取得当前位置")),
      {enableHighAccuracy:false,timeout:12_000,maximumAge:10*60*1000}
    );
  });
}
